import React, { Fragment } from "react";
import { Formik } from "formik";

import { Box, CircularProgress } from "@mui/material";

import { notificationFormSchema } from "./schema/notifications.schema";

import { useNotificationForm } from "./hook/useNotificationForm";
import { INotificationFormMode } from "./hook/interface";

import NotificationForm from "./NotificationForm";
import PreviewModal from "../modal/PreviewModal";

interface Props {
  mode: INotificationFormMode;
  onRefIdLoaded?: (refId?: string) => void;
}

const NotificationFormikContainer: React.FC<Props> = ({
  mode,
  onRefIdLoaded,
}) => {
  const { state, actions } = useNotificationForm(mode);
  const { initialValues, previewOpen, refId } = state;

  React.useEffect(() => {
    if (onRefIdLoaded && refId) {
      onRefIdLoaded(refId);
    }
  }, [refId, onRefIdLoaded]);

  if (!initialValues) {
    return (
      <Box mt={4} display="flex" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={notificationFormSchema}
        onSubmit={actions.handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Fragment>
            <NotificationForm
              formikProps={formik}
              formHookValues={state}
              formHookActions={actions}
            />
            <PreviewModal
              open={previewOpen}
              onClose={actions.closePreview}
              title={formik.values.title}
              content={formik.values.content}
            />
          </Fragment>
        )}
      </Formik>
    </Fragment>
  );
};

export default NotificationFormikContainer;
